<div>
    <div class="row">
        <div class="column">
            <mm-from-account-details-condensed [subtitle]="subtitle"></mm-from-account-details-condensed>
        </div>
        <div class="column">
            <mm-payee-details-check></mm-payee-details-check>
        </div>
    </div>
    <mm-transaction-details-check-condensed [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"></mm-transaction-details-check-condensed>
    <mm-twe-details-section 
        *ngIf="isIraTransaction"
        [transactionType]="check"
        data-testid="twe-details-section_check">
    </mm-twe-details-section>
    <mm-ptrs-details-condensed *ngIf="isPtrsTransaction" data-testid="ptrs-details-section_check"></mm-ptrs-details-condensed>
</div>